module.exports = __webpack_public_path__ + "static/img/icon_rjyf_rjfw_zx (1).fa516c32.png";